import React, { useState } from 'react'
import { Button, Modal, Select, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const CloseOutModal = ({ visible, onClose, onConfirm, onSelectOption }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false)
    // const handleConfirm = () => {

    //     setTimeout(() => {
    //         onConfirm();
    //     }, 1000);
    // };
    const handleConfirm = () => {
        if (selectedOption === null) {
            setError('Please select an option.'); // Display error if no option is selected
        } else {
            setLoader(true)
            setError(''); // Clear error if an option is selected
            setTimeout(() => {
                onConfirm(selectedOption);
                setLoader(false)
            }, 1000);
        }
    };
    return (
        <div>

            <Modal
                title="Close- Open WO"
                visible={visible}
                onCancel={onClose}
                footer={false}
            >
                <Spin
                    spinning={loader}
                    indicator={<LoadingOutlined
                        style={{
                            fontSize: 24,
                        }}
                        spin
                    />}>
                    <p style={{ fontWeight: 'bold' }}>Is Locomotive Serviceable?</p>
                    <Select
                        style={{ width: '100%' }}
                        onChange={(value) => {
                            setSelectedOption(value);
                            onSelectOption(value);
                            setError(''); // Clear error when an option is selected
                        }}
                        value={selectedOption}
                        required
                        placeholder={'Select the option'}
                    >
                        <Select.Option value="1">Yes</Select.Option>
                        <Select.Option value="0">No</Select.Option>
                    </Select>
                    {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>} {/* Display error message */}
                    <div style={{ marginTop: '10px', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
                        <Button onClick={handleConfirm} style={{ background: '#2963AD', color: 'white', width: '30%' }}>Submit</Button>
                    </div>
                </Spin>
            </Modal>

        </div>
    )
}

export default CloseOutModal